// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"554cc656","453":"23854bdc"}[chunkId] + ".chunk.js";
};